/* eslint-disable no-unused-vars */
import { computed } from 'vue';

import { useStore } from 'vuex';
import { VuexStore } from '@/interfaces/VuexStore';
import { key } from '@/setup/store';

const useMenu = () => {
  const { state } = useStore<VuexStore>(key)

  const menu = computed(() => {
    if (!state.evento) {
      return []
    }
    const estructura = Object.entries(state.evento.estructura)
      .filter(([key, valor]) => valor > 0 && key !== 'locaciones')
      .map(([clave, _]) => clave)

    return estructura
  })
  return {
    menu
  }
}

export default useMenu